import { IEmployee, IRoleAdmin } from "./../../interfaces/index";
import { State } from "./../state";
import { EmployeesModState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { indexOfCb } from "@/utils";

export const mutations = {
    setEmployees(state: EmployeesModState, payload: IEmployee[]) {
        state.employees = payload;
    },

    setEmployee(state: EmployeesModState, payload: IEmployee) {
        const idx = indexOfCb(state.employees, (v: IEmployee) => {
            return v.id === payload.id;
        });

        if (idx >= 0) {
            state.employees[idx] = payload;
        } else {
            state.employees.push(payload);
        }
    },
    removeEmployee(state: EmployeesModState, payload: IEmployee) {
        const idx = indexOfCb(state.employees, (v: IEmployee) => {
            return v.id === payload.id;
        });
        if (idx >= 0) {
            state.employees.splice(idx, 1);
        }
    },
    setRoles(state: EmployeesModState, payload: IRoleAdmin[]) {
        state.employeeRoles = payload;
    },
    setRole(state: EmployeesModState, payload: IRoleAdmin) {
        const idx = indexOfCb(state.employeeRoles, (v: IRoleAdmin) => {
            return v.id === payload.id;
        });

        if (idx >= 0) {
            state.employeeRoles[idx] = payload;
        } else {
            state.employeeRoles.push(payload);
        }
    },
};

export const { commit } = getStoreAccessors<EmployeesModState, State>("");

export const commitSetEmployees = commit(mutations.setEmployees);
export const commitSetEmployee = commit(mutations.setEmployee);
export const commitSetRoles = commit(mutations.setRoles);
export const commitSetRole = commit(mutations.setRole);
export const commitRemoveEmployee = commit(mutations.removeEmployee);